import React from 'react';
import './AppPromo.scss';
import { useAnimateOnScroll } from '../../Utils/hooks/useAnimateOnScroll';

import phoneImageWebp from '../../Assets/images/app_promo_phone.webp';
import phoneImage from '../../Assets/images/app_promo_phone.png';
import appleStoreBadge from '../../Assets/images/app_promo_apple_store_new.png';
import googlePlayBadge from '../../Assets/images/app_promo_google_play_new.png';

const AppPromo = () => {
  const sectionRef = useAnimateOnScroll();
  const imageRef = useAnimateOnScroll();
  const textRef = useAnimateOnScroll();

  return (
    <section ref={sectionRef} className="app-promo slide-up">
      <div className="container app-promo__inner">
        <div ref={imageRef} className="app-promo__col-image scale-in">
          <picture>
            <source srcSet={phoneImageWebp} type="image/webp" />
            <img
              src={phoneImage}
              alt="HaulSync Driver App on mobile"
              className="app-promo__phone-img"
              width="814"
              height="427"
            />
          </picture>
        </div>

        <div ref={textRef} className="app-promo__col-text right-in">
          <h2 className="app-promo__title">
            Built for{' '}
            <span className="app-promo__title-highlight">Drivers</span>
            {' '}on the Move
          </h2>

          <p className="app-promo__description">
            Accept jobs, track routes, and manage your work — all from one
            simple app. Stay updated in real time and keep every delivery on
            track without the hassle.
          </p>

          <div className="app-promo__badges">
            <a
              href={process.env.REACT_APP_APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="app-promo__badge-link"
              aria-label="Download on the App Store"
            >
              <img
                src={appleStoreBadge}
                alt="Download on the App Store"
                className="app-promo__badge-img"
                width="145"
                height="76"
              />
            </a>
            <a
              href={process.env.REACT_APP_PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="app-promo__badge-link"
              aria-label="Get it on Google Play"
            >
              <img
                src={googlePlayBadge}
                alt="Get it on Google Play"
                className="app-promo__badge-img"
                width="163"
                height="74"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppPromo;
